import { useEffect, useRef } from "react";
import { useSession } from "../Context/SessionContext";
import fcmService from "../services/fcmService";
import { useDispatch } from "react-redux";
import { fetchNotifications } from "../Redux/Slice/Notifications/GetNotification";

const useFCM = () => {
  const { session } = useSession();
  const dispatch = useDispatch();
  const initializedRef = useRef(false);

  useEffect(() => {
    const initializeFCM = async () => {
      // Only initialize if user is authenticated
      const token = sessionStorage.getItem("access_token");
      if (!token || !session?.LoginId) {
        return;
      }

      // Prevent multiple initializations
      if (initializedRef.current) {
        return;
      }

      try {
        // Initialize FCM service
        await fcmService.initialize();

        // Set up foreground message handler
        fcmService.setupForegroundMessageHandler(() => {
          // console.log("[useFCM] Foreground message received:", payload);

          if (session?.LoginId) {
            dispatch(fetchNotifications({ LoginId: session.LoginId, PageNumber: 1, PageSize: 10 }));
          }
        });

        initializedRef.current = true;
      } catch (error) {
        console.error("[useFCM] Error initializing FCM:", error);
      }
    };

    const timer = setTimeout(() => {
      initializeFCM();
    }, 1000);

    return () => clearTimeout(timer);
  }, [session?.LoginId, dispatch]);

  return {
    fcmService,
  };
};

export default useFCM;
